const formatValue = (value, isCurrency, label) => {
  const safeValue = Number(value) || 0;

  if(label === "Total Bookings") return safeValue

  if (isCurrency) {
    return new Intl.NumberFormat("en-PK", {
      style: "currency",
      currency: "PKR",
      maximumFractionDigits: 0,
    }).format(safeValue);
  }

  return new Intl.NumberFormat("en-PK", {
    maximumFractionDigits: 0,
  }).format(safeValue);
};

const StatsCard = ({ label, value, tone = "primary", isCurrency = false, icon: Icon }) => {
  return (
    <div className="widget-stat card h-100">
      <div className="card-body p-2">
        <div className="media ai-icon align-items-center">
          <span
            className={`me-2`}
            style={{ width: "46px", height: "46px", fontWeight: 600 }}
          >
            {Icon ? <Icon size={20} /> : null}
          </span>
          <div className="media-body">
            <p className="mb-1 text-muted">{label}</p>
            <h4 className="mb-0">{formatValue(value, isCurrency, label)}</h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
